import Dropdown from "./Dropdown";
import Radio from "./Radio";
import InputText from "./InputText";
import AutoAddress from "./AutoAddress";
import AutoAddressMultifield from "./AutoAddressMultifield";
import AgentSearch from "./AgentSearch";
import { isAgentSearchField } from "../../services/agentSearchUtils";
export var fieldRegistry = {
    dropDown: Dropdown,
    radio: Radio,
    inputText: InputText,
    autoAddress: AutoAddress,
    autoAddressMultifield: AutoAddressMultifield,
};
export function resolveFieldComponent(fieldConfig) {
    if (isAgentSearchField(fieldConfig)) {
        return AgentSearch;
    }
    return fieldRegistry[fieldConfig.type] || fieldRegistry.inputText;
}
